// Generate code from clean architecture template

import { ConfigSystemEntity } from '@/domains/config-system/entities';
import {
  CreateConfigSystemPayload,
  QueryConfigSystemPayload,
  RankingConfigurationPayload,
  UpdateConfigSystemPayload,
} from '@/domains/config-system/ports/payloads';
import { ConfigSystemRepository } from '@domains/config-system/ports/repositories';
import {
  CREATE_CONFIG_SYSTEM,
  FIND_CONFIG_SYSTEM_BY_KEY,
  UPDATE_SALES_TARGET_RANKING,
  UPDATE_VALUE_CONFIG_SYSTEM,
} from '../../graphql';
import { HttpClientAdapter } from '@/graphql/http-client-adapter';

export class ConfigSystemHttpRepository implements ConfigSystemRepository {
  async findByKey(payload: QueryConfigSystemPayload): Promise<ConfigSystemEntity | undefined> {
    const response: ConfigSystemEntity = await HttpClientAdapter.query<ConfigSystemEntity>({
      query: FIND_CONFIG_SYSTEM_BY_KEY,
      dataKey: 'ConfigSystem_findByKey',
      variables: payload,
    });
    return response;
  }
  async updateValue(payload: UpdateConfigSystemPayload): Promise<ConfigSystemEntity> {
    const response = await HttpClientAdapter.mutate<ConfigSystemEntity>({
      mutation: UPDATE_VALUE_CONFIG_SYSTEM,
      variables: { input: payload },
      dataKey: 'ConfigSystem_updateValue',
    });

    return response;
  }
  async create(payload: CreateConfigSystemPayload): Promise<ConfigSystemEntity> {
    const response = await HttpClientAdapter.mutate<ConfigSystemEntity>({
      mutation: CREATE_CONFIG_SYSTEM,
      variables: { input: payload },
      dataKey: 'ConfigSystem_create',
    });
    return response;
  }
  async updateSalesTargetRanking(
    payload: RankingConfigurationPayload[],
  ): Promise<ConfigSystemEntity> {
    const response = await HttpClientAdapter.mutate<ConfigSystemEntity>({
      mutation: UPDATE_SALES_TARGET_RANKING,
      variables: { input: payload },
      dataKey: 'ConfigSystem_updateSalesTargetRanking',
    });
    return response;
  }
}
